import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const referrerRewardPlanMenuRegistry = {
    core_referrerRewardPlan: {
        label: "Referrer Reward Plan",
        link: PAGE_URL.REFERRER_REWARD_PLAN_PAGE,
        key: PAGE_URL.REFERRER_REWARD_PLAN_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default referrerRewardPlanMenuRegistry;
